import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @ignore - internal component.
 */
function ExpandMore(props) {
  return (
    <SvgIcon {...props}>
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
    </SvgIcon>
  );
}

export default React.memo(ExpandMore);



// WEBPACK FOOTER //
// ./src/icons/internals/ExpandMore.jsx